// extracted by mini-css-extract-plugin
module.exports = {"root":"CouponSum_root__rkpmq","error":"CouponSum_error__Xwg_b","mobilePreviewError":"CouponSum_mobilePreviewError__pVS8J","balance":"CouponSum_balance__FOzDc"};